import { APARTMENT_TYPE } from '../../constants';

export const isOverallApartmentType = (apartmentType?: { id?: number; type?: string }) =>
  Boolean(
    apartmentType && (apartmentType.id === APARTMENT_TYPE.OVERALL || apartmentType.type?.toLowerCase() === 'overall')
  );
